export default "__VITE_ASSET__60cbcd92__"